import React from 'react';

const LawVision = () => {
  return (
    <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.4984 6.514C21.9484 4.081 18.4224 0 12.2274 0C6.03241 0 2.50641 4.081 0.955406 6.515C-0.0215937 8.048 -0.0215937 9.953 0.955406 11.486C2.50641 13.919 6.03341 18.001 12.2284 18.001C18.4234 18.001 21.9464 13.92 23.4984 11.487C24.4764 9.954 24.4764 8.049 23.4984 6.514ZM12.2274 14C10.5694 14 9.11041 13.183 8.20141 11.94L9.72741 10.414L10.5204 11.207C10.9114 11.598 11.5434 11.598 11.9344 11.207L13.4904 9.651L14.1544 10.315C14.5504 10.711 15.2264 10.43 15.2264 9.871V7.111C15.2264 6.774 14.9534 6.5 14.6154 6.5H11.8554C11.2954 6.5 11.0154 7.177 11.4114 7.572L12.0754 8.236L11.2264 9.085L10.4334 8.292C10.0424 7.901 9.41041 7.901 9.01941 8.292L7.32641 9.985C7.26241 9.666 7.22741 9.336 7.22741 8.999C7.22741 6.238 9.46641 3.999 12.2274 3.999C14.9884 3.999 17.2274 6.238 17.2274 8.999C17.2274 11.76 14.9884 14 12.2274 14Z"
        fill="white"
      />
    </svg>
  );
};

export default LawVision;
